import type { InferSelectModel } from 'drizzle-orm';
import { pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';
import { albums } from './albums';

/**
 * Contas do Instagram conectadas ao painel (Instagram API com login do Instagram) — usadas pra
 * importar posts na galeria. Tabela técnica: desconectar apaga a linha (sem soft delete).
 * O token de longa duração vale 60 dias e é renovado no uso e pelo robô de hora em hora
 * (ver `instagram.service.ts` e `instagram.sync.ts`).
 */
export const instagramAccounts = pgTable('instagram_accounts', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  /** ID da conta na API do Instagram (`user_id` do `/me`). */
  igUserId: text('ig_user_id').notNull().unique(),
  username: text('username').notNull(),
  accessToken: text('access_token').notNull(),
  tokenExpiresAt: timestamp('token_expires_at').notNull(),
  /** Última troca/renovação do token — a API só renova token com mais de 24h. */
  tokenRefreshedAt: timestamp('token_refreshed_at')
    .notNull()
    .$defaultFn(() => new Date()),
  /** Álbum "Instagram · @conta" da galeria, criado pelo robô — guarda as fotos dos últimos posts. */
  albumId: uuid('album_id').references(() => albums.id),
  /** Última passada do robô e o erro dela (vazio se deu certo) — aparece no painel. */
  lastSyncAt: timestamp('last_sync_at'),
  lastSyncError: text('last_sync_error'),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export type InstagramAccount = InferSelectModel<typeof instagramAccounts>;
